import { useSiteDataMenu } from "@hooks"
import { Button } from "@heroui/react"
import { Cog6ToothIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const SiteDataMenu = ({ clientId, view = "MENU" }) => {
  const { open } = useSiteDataMenu(clientId)

  return (
    <div>
      <Button variant="bordered" className="border-white" isIconOnly onPress={() => open(view)}>
        <Cog6ToothIcon className="text-white w-7 h-7" />
      </Button>
    </div>
  )
}

SiteDataMenu.propTypes = {
  clientId: PropTypes.string.isRequired,
  view: PropTypes.string,
}

export default SiteDataMenu